$(function () {
	if (!!$(".form").length) {
		const formStylesInit = () => {
			$("#sg-phishing-footer").css("color", "");
			$("#demo-phishing-banner").remove();
			if (window.location.hash.includes("sgbody")) {
				$(".form").get(0).scrollIntoView();
			}
		}
		let options = { childList: true, subtree: true}
		let observer = new MutationObserver(formStylesInit);
		observer.observe($(".form").get(0), options);
	}
});
